import type { ConstsConfig } from '../declare'

const consts: ConstsConfig[] = [
  {
    name: 'LOGIN',
    value: 'P0001'
  },
]

export default consts